<template>
    <div class="bigbox">   
        <el-container>
            <el-header>
                <div class="content header_top">
                    <div class="header_logo_title">
                        <!-- <img src="../assets/image/logo.jpg" alt="" /> -->
                        <div class="header_title">
                          <div class="header_title_pic">
                            <img :src="siteinfo.logo" alt="">
                          </div>
                          <div>
                            <div class="header_title_chinese">{{siteinfo.sitename}}</div>
                            <div class="header_title_spell">
                              Red Cross Society of China HuaiBei Branch
                            </div>
                          </div>
                        </div>
                     </div>
                     <div class="header_logo_slogan" @click="picbtn(logourl)">
                        <img alt="人道 博爱 奉献" :src="logopic" />
                     </div>
                     <div class="header_search_form">
                        <div class="form_box">
                            <input v-model="query" type="text" id="kw" placeholder="请输入关键字" class="search_kw" name="kw" autocomplete="off" @keyup.enter="gotoSearch"/>
                            <div class="search_div" @click="gotoSearch">
                              <div style="width:22px;height:22px">
                                <img src="../assets/image/bit5.png" id="img" />
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="header_footer">
                    <div class="content header_navlist">
                        <p v-for="(item,index) in navlist" :key="item.id" @mouseover="inbox(item,index)"  @mouseout="outbox" @click="topath(item)">{{item.name}}</p>
                    </div>
                </div>
            </el-header>
            <el-main>
                <div class="content">
                    <router-view></router-view>
                </div>
            </el-main>
            <el-footer class="footer">
                <div class="footer_text">
                    <div>
                      {{siteinfo.sitename}} @copy 版权所有 {{siteinfo.copyright}}&nbsp;&nbsp;<a target="_blank" href="https://beian.miit.gov.cn/">ICP备案号：{{siteinfo.sitenum}}</a>&nbsp;&nbsp;<a target="_blank" href="http://www.hbsredcross.cn/admin">管理登录</a>
                    </div>
                    <div>地址：{{siteinfo.address}}  邮编：{{siteinfo.postcode}}  电话：{{siteinfo.tel}}</div>
                    <div class="footer_text_pic">
                      <div class="footer_text_pic_pic">
                        <a target="_blank" href="https://bszs.conac.cn/sitename?method=show&id=27625DB4183A73DDE053012819ACC2F1">
                          <img src="../assets/image/blue.png" alt="">
                        </a>
                      </div>
                      <div class="footer_text_pic_text">
                        <div class="footer_text_pic_text1">
                          <img src="../assets/image/zz.png" alt="">
                        </div>
                        <div class="footer_text_pic_text2">
                          <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34060002020027">皖公网安备:34060002020027号</a>
                        </div>
                      </div>
                    </div>
                </div>
            </el-footer>
        </el-container>

        <!-- 鼠标移入显示移出隐藏 -->
        <transition name="fade-transform">
            <div class="content box" v-show="isshow" @mouseout="outbox" @mouseover="isshow=true">
                <div v-for="(item,index) in boxlist" :key="item.id" @click="hit(item,index)" class="boxdiv">
                    <div class="circle"></div>
                    {{item.name}}
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data(){
        return{
            // navlist:['省红十字会','首页','组织信息','业务活动','信息公开','社会捐赠'],
            navlist:[
                {name:'省红十字会',path:'https://www.ynredcross.cn/'},
                {name:'首页',path:'/first'},
                {name:'组织信息',path:'/tissue'},
                {name:'业务活动',path:'/tissue'},
                {name:'信息公开',path:'/tissue'},
                {name:'社会捐赠',path:'/tissue'},
            ],
            isshow:false,
            // 鼠标移入显示盒子里面的数据
            boxlist:[],
            // 鼠标点击的是哪一个导航
            navlist_i:1,
            // 基本信息列表
            siteinfo:{},
            // 搜索的值
            query:'',
            // 控制内容页与列表页的显示隐藏
            isshow:false,
            // logo图片
            logopic:'',
            // logo图片地址
            logourl:''
        }
    },
    created(){
      this.getDataList()
    },
    methods:{
      // 发送请求，获取数据
      async getDataList(){
        const {data:res}=await this.$http.get('/index/siteInfo')
        if(res.code===200){
          // 获取导航列表数据
          this.navlist=res.data.menus.filter(item=>item.status==1)
          // 获取基本信息列表
          this.siteinfo=res.data.siteinfo
          res.data.pics.forEach(item => {
            switch (item.name){
              case "首页logo右侧":this.logopic=item.imgsrc,this.logourl=item.url
              break;
            }
          });
        }
      },
      // 点击搜索携带参数去到搜索页面
      gotoSearch(){
        this.$router.push({path:'/search',query:{query:this.query}})
      },
      inbox(item,i){
          if(item.sons.length!==0){
              this.isshow=true
          }
          this.boxlist=item.sons.filter(item=>item.status==1)
          this.navlist_i=i
        },
        outbox(){
            this.isshow=false
        },
        // 点击导航栏发生的事件处理函数
        topath(item){
          if(item.name==='首页'){
            return this.$router.push('/first')
          }
          if(item.type===1){
            window.open(item.path)
          }
        },
        // 点击盒子内部文字触发的事件
        hit(item,i){
          if(item.type==2){
            // 外链
            // switch (item.name){
            //   case '捐款公开':this.$router.push({path:'/contribution',query:{donate_name:item.name}})
            //   break;
            //   case '捐物公开':this.$router.push({path:'/benevolence',query:{donate_name:item.name}})
            //   break;
            //   case '资金使用公开':this.$router.push({path:'/fund',query:{donate_name:item.name}})
            //   break;
            //   case '物资发放公开':this.$router.push({path:'/goods',query:{donate_name:item.name}})
            //   break;
            //   default:window.location.href=item.path
            //       //window.sessionStorage.setItem('overNumber',e[1])
            // }
            window.location.href=item.path
          }else{
            this.$router.push({path:'/tissue',query:{pid:item.pid,id:item.id,overNumber:i}})
            // this.$router.go(0)
          }
        },
        // 点击图片跳转
        picbtn(url){
          window.open(url)
        }
    }
}
</script>
<style lang="less" scoped>
.bigbox {
  position: relative;
}
.el-header {
  padding: 0;
  height: 220px !important;
}

.el-main {
  padding: 0;
  margin: 0;
}
.el-footer {
  padding: 0;
  margin-top: 5px;
}
.header_top {
  height: 140px;
  margin-bottom: 1px;
  padding-top:30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header_title {
    // background: url(../assets/image/logo.jpg) no-repeat left;
    // display: inline-block;
    display: flex;
    align-items: center;
    .header_title_pic{
      height: 90px;
      width: 90px;
    }
    .header_title_chinese {
      margin-left: 10px;
      font-size: 42px;
      color: #d6000f;
      font-weight: bolder;
      font-family: "华文行楷";
    }
    .header_title_spell {
      margin-left: 10px;
      font-size: 13px;
      margin-top: 10px;
      color: #666666;
      font-family: Arial, Helvetica, sans-serif;
      font-weight: 800;
      // text-transform: uppercase;
    }
  }
  .header_logo_slogan {
    // position: absolute;
    // left: 665px;
    // top: 40px;
    width: 283px;
    height: 65px;
  }
  .header_search_form {
    // position: absolute;
    // left: 1000px;
    // top: 50px;
    width: 283px;
    height: 44px;
    border: 1px solid #bd1a1a;
    display: inline-block;
    .form_box{
      display: flex;
      input{
        width: 230px;
        height: 42px;
        display: inline-block;
        border: none;
        font-size: 16px;
        padding-left: 10px;
      }
      .search_div{
          width: 49px;
          height: 45px;
          background-color: #bd1a1a;
          // display: inline-block;
          // vertical-align: middle;
          // text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
      }
    }
    input {
      width: 230px;
      height: 35px;
      display: inline-block;
      border: none;
    }
  }
}
.header_footer {
  margin: 0; padding: 0;
  height: 50px;
  background-color: #d6000f;
  .header_navlist {
    display: flex;
    justify-content: space-between;
    p {
      flex: 1;
      color: white;
      font-weight: bolder;
      text-align: center;
      margin: 0;
      line-height: 50px;
      border-right: 1px solid #fff;
      cursor: pointer;
    }
    p:last-child {
      border-right: none;
    }
  }
}

.footer {
  padding: 25px 0;
  background-color: #3f3f3f;
  height: 150px !important;
  width: 100%;
  color: #fff;
  font-size: 14px;
  .footer_nav {
    text-align: center;
    span {
      padding: 0 6px;
      border-right: 1px solid #d7d7d7;
      cursor: pointer;
    }
  }
  .footer_text {
    margin-top: 5px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    >div{
      margin-top: 10px;
    }
    .footer_text_pic{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .footer_text_pic_pic{
        width: 65px;
        height: 65px;
        margin-right: 25px;
      }
      .footer_text_pic_text{
        display: flex;
        justify-content: center;
        .footer_text_pic_text1{
          width: 20px !important;
          height: 20px !important;
        }
        .footer_text_pic_text2{
          margin-left: 8px;
        }
      }
    }
  }
}
.box {
  width: 1160px;
  height: 100px;
  // background-color: red;
  position: absolute;
  left: 50%;
  top: 222px;
  transform: translateX(-50%);
  opacity: 0.9;
  // z-index: 999;
  background-color: #fffaf4;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 30px 20px;
  .boxdiv {
    width: 290px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
.circle {
  width: 10px !important;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  margin-right: 15px;
}
// 设置样式
.fade-transform-leave-active,
.fade-transform-enter-active {  //进入或离开的过程
  transition: all 1s;
}
.fade-transform-enter {  //进入前
  opacity: 0;
  // transform: translate(30px);
  // top:170px
}
.fade-transform-leave-to {  //离开后
  opacity: 0;
  // transform: translate(-30px);
  // top:170px
}
a{
  text-decoration: none;
  color:#fff;
}
a:hover{
  cursor: pointer;
  color:rgb(184, 97, 17);
}
img{
    width: 100%;
    height: 100%;
}
</style>